export default "__VITE_ASSET__Dfr7_F4c__"